import React from 'react';

/** Klarna „Jetzt kaufen, später zahlen"-Hinweis für Checkout-Bereiche. */
export function KlarnaBnplBadge({ testId = 'klarna-bnpl-badge', compact = false }) {
  return (
    <div
      className={`flex items-center gap-3 rounded-xl bg-[#FFEDF3] border border-[#FFB3C7]/60 ${compact ? 'px-3 py-2 mt-2' : 'px-4 py-3 mt-3'}`}
      data-testid={testId}
    >
      <span className="flex-shrink-0 bg-white rounded-md px-1.5 py-1 border border-stone-100">
        <img loading="lazy" decoding="async" src="/payment/klarna.svg" alt="Klarna" className={compact ? 'h-3.5 w-auto' : 'h-4 w-auto'} />
      </span>
      <p className={`${compact ? 'text-[11px]' : 'text-xs'} text-stone-700 leading-snug`}>
        <span className="font-medium text-stone-900">Jetzt kaufen, später zahlen</span> — Ratenkauf mit Klarna im nächsten Schritt verfügbar.
      </p>
    </div>
  );
}

export default KlarnaBnplBadge;
